import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由懒加载，提升首屏速度
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于' }
  },
  {
    path: '/recognition',
    name: 'Recognition',
    component: () => import('@/views/Recognition.vue'),
    meta: { title: '图片裁剪识别' }
  },
  {
    path: '/feature-detect',
    name: 'FeatureDetect',
    component: () => import('@/views/FeatureDetect.vue'),
    meta: { title: '特征检测' }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: '页面不存在' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 全局前置守卫：固定设置标题，所有页面统一为“咸鱼辅助”
router.beforeEach((to, from, next) => {
  document.title = '咸鱼辅助'
  next()
})

export default router
